module.exports = __webpack_public_path__ + "img/IMG_3450_L_Foamcore.2621aa2c.jpg";